import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

export const SITE_URL = 'https://simplygoldproductions.com';
const DEFAULT_OG = `${SITE_URL}/og-image.jpg`;

// Reusable per-page SEO: title, description, canonical, Open Graph, Twitter, JSON-LD.
const Seo = ({
  title,
  description,
  path = '/',
  image = DEFAULT_OG,
  type = 'website',
  noindex = false,
  jsonLd = null,
}) => {
  const canonical = `${SITE_URL}${path === '/' ? '/' : path.replace(/\/$/, '')}`;
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  // Remove the homepage baseline tags shipped in index.html so Helmet stays the
  // single source of truth per route (prevents duplicate/conflicting canonical).
  useEffect(() => {
    document.querySelectorAll('[data-default-seo]').forEach((el) => el.remove());
  }, []);

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Simply Gold Productions" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_CA" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
};

export default Seo;
